import React from 'react';

const SessionFooter = ({
  formData,
  statuses,
  onCancel,
  onSubmit,
  loading,
  editingSession,
  onOpenWorksheets,
  onOpenNotifications
}) => {
  
  const buttonStyle = {
    padding: 'clamp(10px, 2.5vw, 14px) clamp(16px, 4vw, 24px)',
    color: 'white',
    border: 'none',
    borderRadius: '10px',
    cursor: 'pointer',
    fontSize: 'clamp(13px, 2.5vw, 15px)',
    fontWeight: '600',
    transition: 'all 0.2s ease',
    minHeight: '44px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px'
  };

  const getSessionInfo = () => {
    if (formData.session_type === 'training') {
      return (
        <>
          👥 Participants: {formData.participant_ids.length} • 📊 {statuses.find(s => s.id === formData.status_id)?.name || 'Statut non défini'}
        </>
      );
    }
    
    if (formData.session_type === 'blocked' && formData.block_reason) {
      return <>🚫 Raison: {formData.block_reason}</>;
    }
    
    if ((formData.prestation_type === 'note' || formData.session_type === 'note') && formData.maintenance_description) {
      return <>📝 Note enregistrée</>;
    }
    
    return null;
  };

  return (
    <div style={{
      padding: 'clamp(16px, 4vw, 24px)',
      borderTop: '1px solid #dee2e6',
      background: '#f8f9fa',
      borderRadius: '0 0 20px 20px',
      display: 'flex',
      flexDirection: 'var(--footer-direction, row)',
      justifyContent: 'space-between',
      alignItems: 'center',
      gap: 'clamp(12px, 3vw, 16px)'
    }}>
      {/* Informations de session */}
      <div style={{ 
        fontSize: 'clamp(12px, 2.5vw, 14px)', 
        color: '#6c757d',
        display: 'var(--footer-info-display, block)'
      }}>
        {getSessionInfo()}
      </div>
      
      {/* Boutons d'action */}
      <div style={{
        display: 'flex',
        flexDirection: 'var(--buttons-direction, row)',
        gap: 'clamp(8px, 2vw, 12px)',
        flex: 'var(--buttons-flex, 0)'
      }}>
        {/* Bouton Feuilles journalières - mode édition (prestations, blocages et notes) */}
        {editingSession?.id && onOpenWorksheets && (
          <button
            type="button"
            onClick={onOpenWorksheets}
            disabled={loading}
            style={{
              ...buttonStyle,
              background: 'linear-gradient(135deg, #ff9800, #f57c00)',
              flex: 'var(--button-flex, 0)'
            }}
            title="Ouvrir les feuilles journalières de travail"
          >
            <span>📋</span>
            <span>Feuilles</span>
          </button>
        )}

        {/* Bouton Notifier - uniquement en mode édition avec participants */}
        {editingSession?.id && formData.prestation_type !== 'note' && onOpenNotifications && (
          <button
            type="button"
            onClick={onOpenNotifications}
            disabled={loading}
            style={{
              ...buttonStyle,
              background: 'linear-gradient(135deg, #17a2b8, #138496)',
              flex: 'var(--button-flex, 0)'
            }}
            title="Envoyer une notification aux participants"
          >
            <span>📧</span>
            <span>Notifier</span>
          </button>
        )}

        <button
          type="button"
          onClick={onCancel}
          disabled={loading}
          style={{
            ...buttonStyle,
            background: 'linear-gradient(135deg, #6c757d, #5a6268)',
            flex: 'var(--button-flex, 0)'
          }}
        >
          <span>❌</span>
          <span>Annuler</span>
        </button>
        
        <button
          onClick={onSubmit}
          disabled={loading}
          style={{
            ...buttonStyle,
            background: loading 
              ? 'linear-gradient(135deg, #6c757d, #5a6268)' 
              : 'linear-gradient(135deg, #667eea, #764ba2)',
            cursor: loading ? 'not-allowed' : 'pointer',
            boxShadow: loading ? 'none' : '0 4px 15px rgba(102, 126, 234, 0.3)',
            flex: 'var(--button-flex, 0)'
          }}
          onMouseEnter={(e) => {
            if (!loading) {
              e.target.style.transform = 'translateY(-2px)';
              e.target.style.boxShadow = '0 6px 20px rgba(102, 126, 234, 0.4)';
            }
          }}
          onMouseLeave={(e) => {
            if (!loading) {
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = '0 4px 15px rgba(102, 126, 234, 0.3)';
            }
          }}
        >
          <span style={{ fontSize: 'clamp(16px, 3vw, 18px)' }}>
            {loading ? '⏳' : (editingSession?.id ? '💾' : '✨')}
          </span>
          <span>
            {loading ? 'Enregistrement...' : (editingSession?.id ? 'Modifier' : 'Créer')}
          </span>
        </button>
      </div>
    </div>
  );
};

export default SessionFooter;